import React from 'react';
import { Meeting } from '@/types/meeting';
import { FileUploader } from '@/components/files/FileUploader';
import { FileList } from '@/components/files/FileList';
import { TagManager } from '@/components/files/TagManager';

interface FileSectionProps {
  formData: Partial<Meeting>;
  onChange: (data: Partial<Meeting>) => void;
}

export function FileSection({ formData, onChange }: FileSectionProps) {
  return (
    <div className="space-y-8">
      <FileUploader
        onUpload={(newFiles) => {
          onChange({
            ...formData,
            attachments: [...(formData.attachments || []), ...newFiles]
          });
        }}
      />

      <div className="border-t border-gray-200 pt-8">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Manage Tags</h3>
        <TagManager
          tags={formData.tags || []}
          onCreateTag={(tag) => {
            const newTag = {
              ...tag,
              id: Math.random().toString(36).substr(2, 9),
              createdAt: new Date(),
              updatedAt: new Date(),
            };
            onChange({
              ...formData,
              tags: [...(formData.tags || []), newTag]
            });
          }}
          onUpdateTag={(id, updates) => {
            onChange({
              ...formData,
              tags: (formData.tags || []).map(tag =>
                tag.id === id ? { ...tag, ...updates } : tag
              )
            });
          }}
          onDeleteTag={(id) => {
            onChange({
              ...formData,
              tags: (formData.tags || []).filter(tag => tag.id !== id)
            });
          }}
        />
      </div>

      <div className="border-t border-gray-200 pt-8">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Attached Files</h3>
        <FileList
          files={formData.attachments || []}
          tags={formData.tags || []}
          onTagFile={(fileId, tagIds) => {
            onChange({
              ...formData,
              attachments: formData.attachments?.map(file =>
                file.id === fileId
                  ? {
                      ...file,
                      tags: tagIds.map(id =>
                        formData.tags?.find(tag => tag.id === id) || {
                          id,
                          name: '',
                          color: '#000000',
                          createdAt: new Date(),
                          updatedAt: new Date()
                        }
                      )
                    }
                  : file
              ) || []
            });
          }}
          onDeleteFile={(fileId) => {
            onChange({
              ...formData,
              attachments: formData.attachments?.filter(file => file.id !== fileId) || []
            });
          }}
        />
      </div>
    </div>
  );
}